import { LOGIN_FAILURE, LOGIN_REQUEST, LOGIN_SUCCESS, LOGOUT, USER_ID } from "./Auth.actionType";

export const login_request = () => {
  return {
    type: LOGIN_REQUEST
  };
};
export const login_success = (payload) => {
  return {
    type: LOGIN_SUCCESS,
    payload: payload,
  };
};
export const login_failure = () => {
  return {
    type: LOGIN_FAILURE,
  };
};
export const logout = ()=>{
  return{
      type : LOGOUT
  }
}
export const set_user_id = (payload)=>{
  return {
    type: USER_ID,
    payload: payload,
  };
}
